module.exports = __webpack_public_path__ + "img/pic_watch_y007@2x.0683d62a.png";